/* PaperStar theme behaviour
   Depends on coloring.js (SCENES, pageSVG, Studio, starRow, slRenderAll) */

(function(){
  var $  = function(s,r){return (r||document).querySelector(s);};
  var $$ = function(s,r){return [].slice.call((r||document).querySelectorAll(s));};

  /* ---------- money ---------- */
  function money(cents){
    if(window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, window.slMoneyFormat);
    return '$' + (cents/100).toFixed(2).replace(/\.00$/,'');
  }

  /* ---------- toast ---------- */
  function toast(msg){
    var t = $('#sl-toast');
    if(!t){ t = document.createElement('div'); t.id='sl-toast'; t.className='toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('on');
    clearTimeout(t._t); t._t = setTimeout(function(){ t.classList.remove('on'); }, 2600);
  }

  /* ---------- drawers ---------- */
  function closeDrawers(){
    $$('.drawer').forEach(function(d){ d.classList.remove('on'); });
    var s = $('#scrim'); if(s) s.classList.remove('on');
  }
  function openDrawer(sel){
    var d = $(sel); if(!d) return;
    d.classList.add('on');
    var s = $('#scrim'); if(s) s.classList.add('on');
  }
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-open-cart]')){ e.preventDefault(); openDrawer('#cart-drawer'); renderCart(); return; }
    if(e.target.closest('[data-open-menu]')){ e.preventDefault(); openDrawer('#menu-drawer'); return; }
    if(e.target.closest('[data-close]') || e.target.id === 'scrim'){ closeDrawers(); }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeDrawers(); });

  /* ---------- cart ---------- */
  function cartFetch(){
    return fetch(window.slRoutes ? window.slRoutes.cart + '.js' : '/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .catch(function(){ return { item_count: 0, items: [], total_price: 0 }; });
  }

  function updateCount(cart){
    $$('[data-cart-count]').forEach(function(el){
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function lineHTML(item, i){
    var props = '';
    if(item.properties){
      props = Object.keys(item.properties)
        .filter(function(k){ return item.properties[k] && k.charAt(0) !== '_'; })
        .map(function(k){ return item.properties[k]; })
        .join(' · ');
    }
    var child = (item.properties && (item.properties["Child's name"] || item.properties['Child name'])) || 'Sam';
    var theme = (item.properties && item.properties['Their world']) || '';
    var key = 'dragon';
    Object.keys(SCENES).forEach(function(k){ if(SCENES[k].label === theme) key = k; });

    return '<div class="cline">' +
      '<div class="cline-thumb" data-sl-page data-name="'+ esc(child) +'" data-theme="'+ key +'" data-flat="true"></div>' +
      '<div style="flex:1;min-width:0">' +
        '<h4>'+ esc(item.product_title) +'</h4>' +
        '<p class="meta">'+ esc(props || item.variant_title || '') +'</p>' +
        '<div style="display:flex;align-items:center;gap:12px">' +
          '<span class="qty">' +
            '<button data-line="'+ (i+1) +'" data-qty="'+ (item.quantity-1) +'" aria-label="Decrease">&minus;</button>' +
            '<span>'+ item.quantity +'</span>' +
            '<button data-line="'+ (i+1) +'" data-qty="'+ (item.quantity+1) +'" aria-label="Increase">+</button>' +
          '</span>' +
          '<button class="crm" data-line="'+ (i+1) +'" data-qty="0">Remove</button>' +
        '</div>' +
      '</div>' +
      '<div class="cline-price">'+ money(item.final_line_price) +'</div>' +
    '</div>';
  }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function renderCart(){
    return cartFetch().then(function(cart){
      updateCount(cart);
      var body = $('#cart-drawer-body'), foot = $('#cart-drawer-foot');
      if(body){
        if(!cart.items.length){
          body.innerHTML = '<div class="empty"><h4>Nothing in here yet</h4>' +
            '<p>Make a book and it\'ll show up.</p>' +
            '<a class="btn btn--sm" href="/pages/make-a-book">Start your book</a></div>';
          if(foot) foot.innerHTML = '';
        } else {
          body.innerHTML = cart.items.map(lineHTML).join('');
          if(foot) foot.innerHTML =
            '<div class="total" style="padding:0 0 14px"><span>Subtotal</span><span>'+ money(cart.total_price) +'</span></div>' +
            '<p style="font-size:13px;color:var(--soft);margin:0 0 14px">Taxes and any shipping worked out at checkout. Digital files send instantly.</p>' +
            '<form action="/cart" method="post"><button class="btn btn--wide" type="submit" name="checkout">Checkout</button></form>' +
            '<p style="text-align:center;margin:10px 0 0"><a class="link" href="/cart" style="font-size:14px">View full cart</a></p>';
        }
        slRenderAll(body);
      }
      return cart;
    });
  }

  function changeLine(line, qty){
    return fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function(r){ return r.json(); });
  }

  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-line]');
    if(!b) return;
    e.preventDefault();
    var qty = parseInt(b.dataset.qty, 10);
    changeLine(parseInt(b.dataset.line,10), qty < 0 ? 0 : qty).then(function(){
      renderCart();
      if(document.body.classList.contains('template-cart')) location.reload();
      if(qty === 0) toast('Removed');
    });
  });

  /* ---------- add to cart ---------- */
  var form = $('#product-form');
  if(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';

      /* required fields: text, select, textarea and file inputs alike */
      var missing = $$('[data-required]', form).filter(function(f){
        if(f.type === 'file') return !f.files || f.files.length === 0;
        return !f.value.trim();
      });
      $$('[data-required]', form).forEach(function(f){ f.classList.remove('err'); });
      if(missing.length){
        btn.disabled = false; btn.textContent = label;
        missing.forEach(function(f){ f.classList.add('err'); });
        var m = $('#product-form-msg');
        if(m){
          m.hidden = false; m.className = 'msg bad';
          m.textContent = missing[0].type === 'file'
            ? 'Attach your photo first — it is the whole point.'
            : 'Fill in the highlighted fields first — the book is built from them.';
        }
        missing[0].focus();
        return;
      }

      var hasFiles = $$('input[type=file]', form).some(function(f){ return f.files && f.files.length; });

      function done(res){
        btn.disabled = false; btn.textContent = label;
        if(!res.ok){ toast((res.d && res.d.description) || 'That could not be added'); return; }
        var added = res.d.product_title || (res.d.items && res.d.items[0] && res.d.items[0].product_title) || 'Your book';
        toast(added + ' added to your cart');
        renderCart(); openDrawer('#cart-drawer');
      }
      function fail(){ btn.disabled = false; btn.textContent = label; toast('Something went wrong — try again'); }

      if(hasFiles){
        /* Files can't travel in a JSON payload. Send the form itself as
           multipart — Shopify stores the upload as a file line item
           property on the order — then add any ticked add-ons after. */
        fetch('/cart/add.js', { method:'POST', body: new FormData(form), headers:{'Accept':'application/json'} })
          .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
          .then(done)
          .catch(fail);
      } else {
        var fd = new FormData(form);
        var properties = {};
        fd.forEach(function(v, k){
          var m = k.match(/^properties\[(.+)\]$/);
          if(m && typeof v === 'string' && v) properties[m[1]] = v;
        });
        var items = [{ id: parseInt(fd.get('id'), 10), quantity: 1, properties: properties }];

        fetch('/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items: items })
        })
          .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
          .then(done)
          .catch(fail);
      }
    });
  }

  /* ---------- product page: live preview + running total ---------- */
  var pdpSheet = $('#pdp-sheet');

  function runningTotal(){
    if(!pdpSheet) return;
    var out = $('#pdp-total');
    if(out) out.textContent = money(parseInt(pdpSheet.dataset.basePrice || '0', 10));
  }

  var pdpCfgEl = $('#pdp-config');
  var pdpCfg = pdpCfgEl ? JSON.parse(pdpCfgEl.textContent) : { mode: 'brief', theme: 'dragon' };

  if(pdpSheet){
    if(pdpSheet.dataset.static === 'true'){
      /* ready-made: show what's in the box; photo: the example snippet is
         already server-rendered inside the sheet. */
      if(pdpCfg.mode === 'ready'){
        /* Real artwork, not the old hand-drawn placeholders. */
        var realSrc = {
          cover:    pdpSheet.dataset.realCover,
          coloured: pdpSheet.dataset.realColour,
          line:     pdpSheet.dataset.realLine
        };
        var curKind = 'cover';
        var fallback = function(){
          if(typeof renderKind === 'function'){
            pdpSheet.innerHTML = renderKind(curKind, 'Pip', pdpCfg.theme, { age: 5, page: 4 });
          }
        };
        var drawStatic = function(){
          var src = realSrc[curKind];
          if(!src){ fallback(); return; }
          var img = new Image();
          img.alt = '';
          img.style.cssText = 'width:100%;height:auto;display:block;border-radius:6px';
          /* a missing world image should not leave an empty gray box */
          img.onerror = fallback;
          img.onload = function(){ pdpSheet.innerHTML = ''; pdpSheet.appendChild(img); };
          img.src = src;
        };
        $$('#pdp-kinds [data-kind]').forEach(function(b){
          b.addEventListener('click', function(){
            curKind = b.dataset.kind;
            $$('#pdp-kinds [data-kind]').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
            b.setAttribute('aria-pressed','true');
            drawStatic();
          });
        });
        drawStatic();
      }
    } else {
      /* custom story: the live colourable preview */
      var pSrc = lineSources(pdpSheet);
      var studio  = pSrc ? ImageStudio(pdpSheet, $('#pdp-crayons'), pSrc)
                         : Studio(pdpSheet, $('#pdp-crayons'));
      var nameIn  = $('[data-child-name]');
      var themeIn = $('[data-theme-input]');

      var drawPdp = function(){
        var t = themeIn ? themeIn.value : pdpCfg.theme;
        if(!SCENES[t]) t = pdpCfg.theme;
        /* No name field on the page at all means it is not personalised
           (a ready-made colouring pack), so pass no name. */
        var who = nameIn ? (nameIn.value || 'Maya') : '';
        studio.draw(who, t);
      };
      if(nameIn)  nameIn.addEventListener('input', drawPdp);
      if(themeIn) themeIn.addEventListener('change', drawPdp);
      drawPdp();
    }

    runningTotal();
  }

  /* gift block: reveal on toggle */
  var giftToggle = $('[data-gift-toggle]'), giftFields = $('#gift-fields');
  if(giftToggle && giftFields){
    var syncGift = function(){ giftFields.hidden = !giftToggle.checked; };
    giftToggle.addEventListener('change', syncGift);
    syncGift();
  }

  /* pill groups that feed a hidden line item property (e.g. Tone) */
  $$('[data-prop-pills]').forEach(function(group){
    var input = $('[data-prop-input="' + group.dataset.propPills + '"]');
    group.addEventListener('click', function(e){
      var b = e.target.closest('[data-prop-value]');
      if(!b) return;
      $$('[data-prop-value]', group).forEach(function(x){ x.setAttribute('aria-pressed','false'); });
      b.setAttribute('aria-pressed','true');
      if(input) input.value = b.dataset.propValue;
    });
  });

  /* ---------- variant picker ---------- */
  var variantData = $('#variant-json');
  if(variantData){
    var variants = JSON.parse(variantData.textContent);
    var idField  = $('#variant-id');
    $$('[data-variant-option]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var group = btn.dataset.optionIndex;
        $$('[data-option-index="'+ group +'"]').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
        btn.setAttribute('aria-pressed','true');

        var chosen = $$('[data-variant-option][aria-pressed="true"]').map(function(x){ return x.dataset.variantOption; });
        var match = variants.filter(function(v){
          return chosen.every(function(c){ return v.options.indexOf(c) > -1; });
        })[0];
        if(match){
          idField.value = match.id;
          var pe = $('#pdp-price'); if(pe) pe.textContent = money(match.price);
          pdpSheet.dataset.basePrice = match.price;
          runningTotal();
          var sub = $('#pdp-availability');
          if(sub) sub.textContent = match.available ? '' : 'Sold out';
        }
      });
    });
  }

  /* ---------- home studio ---------- */
  /* ---------- real line-art sources (Gemini images) ---------- */
  function lineSources(el){
    var ds = el.dataset;
    if(!ds.lineDragon) return null;
    return { dragon: ds.lineDragon, space: ds.lineSpace, sea: ds.lineSea, jungle: ds.lineJungle };
  }

  var homeSheet = $('#home-sheet');
  if(homeSheet){
    var hSrc = lineSources(homeSheet);
    var hStudio = hSrc ? ImageStudio(homeSheet, $('#home-crayons'), hSrc)
                       : Studio(homeSheet, $('#home-crayons'));
    var hName = $('#home-name'), hTheme = $('#home-theme'), hEcho = $('#home-name-echo');
    /* The headline says "your child" until a real name is typed;
       the drawing itself always demos with the placeholder name. */
    var hTyped = false;
    function drawHome(){
      hStudio.draw(hName.value, hTheme.value);
      if(hEcho) hEcho.textContent = hTyped ? ((hName.value || '').trim() || 'your child') : 'your child';
    }
    hName.addEventListener('input', function(){ hTyped = true; drawHome(); });
    hTheme.addEventListener('change', drawHome);
    var hr = $('#home-reset'); if(hr) hr.addEventListener('click', drawHome);
    drawHome();
  }

  /* ---------- newsletter inline feedback ---------- */
  $$('form[action*="/contact"]').forEach(function(f){
    if(!f.querySelector('input[name="contact[email]"]')) return;
    f.addEventListener('submit', function(){
      var i = f.querySelector('input[type=email]');
      if(i && !/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(i.value.trim())) return;
      toast('Sending your free page…');
    });
  });

  /* ---------- sticky mobile bar: hide near footer / when a buy button shows ---------- */
  (function(){
    var bar = $('.stickybar');
    if(!bar || !('IntersectionObserver' in window)) return;
    // Anything that would clash with a fixed bottom bar: the page footer,
    // and any primary buy/checkout button that's actually on the page.
    var watch = $$('footer, .buybox, [name="checkout"], .btn--lg');
    if(!watch.length) return;
    var visible = {};
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ visible[e.target._slId] = e.isIntersecting; });
      var anyOnScreen = Object.keys(visible).some(function(k){ return visible[k]; });
      bar.classList.toggle('is-hidden', anyOnScreen);
    }, { rootMargin: '0px 0px -8px 0px' });
    watch.forEach(function(el, i){ el._slId = 'w'+i; io.observe(el); });
  })();

  /* ---------- rotating announcement bar ---------- */
  (function(){
    var track = $('#announce-track');
    if(!track) return;
    var msgs = $$('.announce-msg', track);
    if(msgs.length < 2) return;
    var i = 0;
    setInterval(function(){
      msgs[i].classList.remove('on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('on');
    }, 4200);
  })();

  /* ---------- boot ---------- */
  renderCart();

  window.PaperStarTheme = { renderCart: renderCart, toast: toast, openDrawer: openDrawer };
})();
